import React from 'react';
import Modal from '../../../../component/modal/Modal';
import Button from '../../../../component/ui/Button';

function DateConfirmationModal({
	isOpenPastDate,
	isOpenPBPastDate,
	cancelUsedPastDate,
	confirmUsedPastDate,
	confirmUsedPBPastDate,
}) {
	return (
		<Modal
			className="delivery-modal"
			title="Confirm Past Date"
			isOpen={isOpenPastDate === false ? isOpenPBPastDate : isOpenPastDate}
			onClose={() => cancelUsedPastDate()}
			cancelButton={true}
		>
			<p>You are creating a transaction in the past date. Do you want to continue?</p>

			<div
				style={{
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'flex-start',
					marginTop: '20px',
				}}
			>
				<Button
					button="Proceed"
					type="button"
					className="btn btn-primary"
					onClick={isOpenPastDate ? confirmUsedPastDate : confirmUsedPBPastDate}
				/>
				<span style={{ width: '20px' }}></span>
				<Button
					button="Cancel"
					type="button"
					className="btn btn-danger"
					onClick={() => cancelUsedPastDate()}
				/>
			</div>
		</Modal>
	);
}

export default DateConfirmationModal;
